export function setRouteWaypoints(state, payload) {
    state.routeWaypoints = payload;
}

export function setRoutesLoading(state, payload) {
    state.routesLoading = payload;
}

export function removeAllRouteResults(state) {
    for (const modeKey in state.transportModes) {
        state.transportModes[modeKey].routes = [];
    }
}

export function setTransportModeLoading(state, data) {
    state.transportModes[data.type].loading = data.loading;
}

export function setTransportModeError(state, data) {
    state.transportModes[data.type].error = data.error;
}

export function setRouteResultsByType(state, data) {
    state.transportModes[data.type].routes = data.routes;
}

export function setRouteResultsByTimeType(state, data) {
    let newRoutes = []
    const prepend = data.timeType === 'EARLIER' || data.timeType === 'FIRST'
    if(data.timeType === 'FIRST') {
        data.routes = data.routes.slice(0, 1)
        data.routes[0].isFirstOfDay = true
    }
    if(data.timeType === 'LAST') {
        data.routes = data.routes.slice(-1)
        data.routes[0].isLastOfDay = true
    }
    data.routes.forEach(route => {
        // check if route already exists in routes array
        const routeJourneyCode = route.metadata.journeyCode
        const existingRoute = state.transportModes[data.type].routes.find((existingRoute) => { return existingRoute.metadata.journeyCode === routeJourneyCode })
        if(existingRoute) {
            if(data.timeType === 'FIRST') existingRoute.isFirstOfDay = true
            if(data.timeType === 'LAST') existingRoute.isLastOfDay = true
        } else {
            newRoutes.push(route)
        }
    })
    let routes = prepend ? [...newRoutes, ...state.transportModes[data.type].routes] : [...state.transportModes[data.type].routes, ...newRoutes];
    // sort the routes
    routes = routes.sort((x, y) => {
        return new Date(x.metadata.time.departure.plannedTime) - new Date(y.metadata.time.departure.plannedTime);
    })
    state.transportModes[data.type].routes = routes;
    
}

export function setRouteResultsScrollInformation(state, data) {
    const scrollInformation = state.transportModes[data.type].scrollInformation ? {...state.transportModes[data.type].scrollInformation} : {}
    if (data.scrollInformation.earlierConnectionsHint) scrollInformation.earlierConnectionsHint = data.scrollInformation.earlierConnectionsHint
    if (data.scrollInformation.laterConnectionsHint) scrollInformation.laterConnectionsHint = data.scrollInformation.laterConnectionsHint
    state.transportModes[data.type].scrollInformation = scrollInformation; 
}


export function setSelectedTransportModes(state, selectedModes) {
    for (const modeKey in state.transportModes) {
        state.transportModes[modeKey].selected = selectedModes.includes(modeKey);
    }
}

export function setTransportModeSelected(state, modeKey) {
    state.transportModes[modeKey].selected = true;
}

export function setManualTransportMode(state, modeKey) {
    if(!state.manualTransportModes.includes(modeKey)) {
        state.manualTransportModes.push(modeKey);
    }
}

export function clearManualTransportModes(state) {
    state.manualTransportModes = [];
}

export function setActiveRouteId(state, payload) {
    state.activeRouteId = payload;
}

export function setActiveRouteMode(state, payload) {
    state.activeRouteMode = payload;
}

export function setActiveTransportModeTab(state, payload) {
    state.activeTransportModeTab = payload;
}

export function setRouteCorridor(state, payload) {
    state.routeCorridor = payload;
}

export function setDetailRouteId(state, payload) {
    state.detailRouteId = payload;
}

export function setRouteShortTermParkingZone(state, {type, value}) {
    state.routeShortTermParkingZone[type] = value;
}

export function setRouteCountryInfo(state, {type, value}) {
    state.routeCountryInfos[type] = value
}

export function setRouteGreenzones(state, {type, value}) {
    state.routeGreenzones[type] = value
}
